import { pipe } from 'fp-ts/function';
import { createAuthorizedGetRequest, decode, fetchApi } from '@/services/api';
import { chain } from 'fp-ts/TaskEither';
import { TemplateCategoryList } from '@/services/api/resources/template/category/codec';

const baseUrl = '/v2/template-categories';

export const list = () => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(TemplateCategoryList)),
);
